/* @flow */

export const ParentSymbol = Symbol('Parent');
export const NameRegistrySymbol = Symbol('NameRegistry');
export const ModuleRegistrySymbol = Symbol('ModuleRegistry');
export const CurrentModuleSymbol = Symbol('CurrentModule');
export const TypeConstructorRegistrySymbol = Symbol('TypeConstructorRegistry');
export const InferrerSymbol = Symbol('Inferrer');
export const TraverseValueSymbol = Symbol('TraverseValue');
export const TraverseTypeSymbol = Symbol('TraverseType');
export const TypeSymbol = Symbol('Type');
export const TypeParametersSymbol = Symbol('TypeParameters');
export const TypePredicateRegistrySymbol = Symbol('TypePredicateRegistry');
